/* template */
<template><div class="journey-container"><div class="single-city"><mpx-view :class="({'move-r':isExchange, placeholder:!fromCitysName})" @tap="goPage('currentFromCity')" class="single-city-left"><div class="max-ellipsis">{{fromCitysName}}</div></mpx-view><mpx-view :class="({'move-l':isExchange, placeholder:!toCitysName})" @tap="goPage('currentToCity')" class="single-city-right"><div class="max-ellipsis">{{toCitysName}}</div></mpx-view><mpx-view @tap="exchange" class="change-btn"><mpx-image :class="(isExchange ? 'rotate' : '')" mode="widthFix" :src="(exchangeWrapperIcon)" class="change-btn-wrapper"/><mpx-image mode="widthFix" :src="(exchangeIcon)" class="change-btn-icon" v-if="(exchangeIcon)"/></mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m514292f5"}'>
@keyframes Rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(180deg)

.journey-container
  .single-city
    box-sizing border-box
    height 54px
    position relative
    .change-btn
      @extend .expand-click
      position absolute
      left 50%
      top 50%
      transform translateX(-50%) translateY(-50%)
      width 24px
      height 24px
      &-wrapper
        width 100%
        &.rotate
          animation Rotate .3s linear
      &-icon
        width 100%
        position absolute
        left 50%
        top 50%
        transform translateX(-50%) translateY(-50%)
    &-left, &-right
      @extend .flex-center
      position absolute
      height 100%
      white-space nowrap
      color #333
      font-size 20px
      font-weight 500
      font-family 'PingFangSC-Medium'
      &.placeholder
        width 100px
      .max-ellipsis
        max-width 150px
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        min-width 100px
    &-right
      text-align right 
    .move-l, .move-r
      transition all .3s
    &-left, &-right.move-l
      left 0
      transform translateX(0)
    &-right, &-left.move-r
        left 100%
        transform translateX(-100%)
  .mutiple-city
    box-sizing border-box
    height 114px
    @extend .flex-center
    .list-style
      width 28px
      flex none
      display flex
      flex-direction column
      height 100%
      .point
        height 50%
        width 100%
        @extend .flex-center
        &::after
          content ''
          display block
          width 8px
          height 8px
          border-radius 50%
          background #06B87C
          margin-left 3px
        &:last-child::after
          background #FF6400
    .citys
      flex 1
      height 100%
      overflow hidden
      border-bottom 0.5px solid #EEEEEE
      .placeholder
        width 100%
        height 50%
        box-sizing border-box
        border-bottom 0.5px solid #EEEEEE
        position relative
        .mutiple-city-top, .mutiple-city-bottom
          width 100%
          min-height 20px
          position absolute
          transform translateY(-50%)
          color #333
          font-size 20px
          font-weight 500
          font-family 'PingFangSC-Medium'
          .max-ellipsis
            width 100%
            white-space nowrap
            overflow hidden
            text-overflow ellipsis
            .tip
              font-size 12px
              color #999
              font-family 'PingFangSC'
              font-weight 400
              margin-left 8px
              white-space inherit
        .move-t, .move-b
          transition all .3s
        .mutiple-city-top
          top 50%
          &.move-b
            top 150%
        .mutiple-city-bottom
          top 150%
          &.move-t
            top 50%
    .change-btn
      height 100%
      width 42px
      flex none
      border-bottom 1px solid #EEEEEE
      @extend .flex-center
      justify-content flex-end
      .change-icon
        width 24px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m514292f5"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex514292f5%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex514292f5%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m514292f5"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index514292f5/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
